/* eslint-disable */
export const MODULE_NAME = 'notification';
export const AUTO_DISMISS = 15;